/**
 * TasksOverviewPanel — Board-Header-Panel (Phase 4 Plan 01, TASK-02).
 *
 * Zeigt board-weit:
 *   - "Heute: N"   — Anzahl offener Tasks mit dueDate <= today
 *   - "Diese Woche: M" — Anzahl offener Tasks mit dueDate <= today + 7d
 *
 * Klick auf "Heute" toggelt das Board-Filter (store.taskFilterActive). Bei
 * aktivem Filter rendert das Board nur Karten mit heute-faelliger Task
 * (Logik in Board.tsx via taskBadgeState).
 *
 * CI-Farben: #E9FF57 (aktiver Chip) + #1A1A1A (Text auf gelb) + #DAD9D9
 * (inaktive Chip-Border). Niemals weisse Schrift auf gelb.
 */

import { Bell, Calendar } from 'lucide-react';
import { useLeadBoard } from '../store/useLeadBoard';

export default function TasksOverviewPanel() {
  const taskCountToday = useLeadBoard((s) => s.taskCountToday);
  const taskCountWeek = useLeadBoard((s) => s.taskCountWeek);
  const taskFilterActive = useLeadBoard((s) => s.taskFilterActive);
  const setTaskFilterActive = useLeadBoard((s) => s.setTaskFilterActive);

  const todayActive = taskFilterActive;

  return (
    <div className="flex items-center gap-2" aria-label="Tasks-Uebersicht">
      <button
        type="button"
        onClick={() => setTaskFilterActive(!todayActive)}
        aria-pressed={todayActive}
        className={
          todayActive
            ? 'inline-flex items-center gap-1.5 px-3 py-1.5 rounded text-sm font-medium bg-[#E9FF57] text-[#1A1A1A] hover:bg-[#d4ea4d]'
            : 'inline-flex items-center gap-1.5 px-3 py-1.5 rounded text-sm font-medium bg-[#DAD9D9] text-[#1A1A1A] hover:bg-gray-300'
        }
        title={
          todayActive
            ? 'Filter aktiv — Klick um alle Karten wieder zu zeigen'
            : 'Klick um nur Karten mit heute-faelliger Task zu zeigen'
        }
      >
        <Bell className="w-4 h-4" />
        Heute: {taskCountToday}
      </button>
      <span
        className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded text-sm bg-white border border-[#DAD9D9] text-[#1A1A1A]"
        aria-label="Tasks diese Woche"
      >
        <Calendar className="w-4 h-4" />
        Diese Woche: {taskCountWeek}
      </span>
    </div>
  );
}
